import React, { Component } from 'react'

import * as GeometryActions from '../../actions/GeometryActions'
import * as LocationActions from '../../actions/LocationActions'

const google = window.google

class LocationPicker extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.handleTextInput = this.handleTextInput.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)

    // Default state
    this.autocomplete = null
    this.geocoder = new google.maps.Geocoder()
  }

  componentDidMount() {
    this.initializeAutoComplete()
  }

  initializeAutoComplete() {
    const autoCompleteInput = document.getElementById('searchTextField')

    // Restrict autocomplete to cities defined by component properties
    const autoCompleteOptions = {
      types: ['(regions)'],
      componentRestrictions: { country: this.props.restrictToCountries }
    }

    this.autocomplete = new google.maps.places.Autocomplete(
      autoCompleteInput,
      autoCompleteOptions
    )

    // Handle selection of autocomplete entries
    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      this.handleAutoCompleteSelection()
    })
  }

  handleAutoCompleteSelection() {
    const place = this.autocomplete.getPlace()

    if (place.geometry) {
      GeometryActions.change(place.geometry.location)
      LocationActions.getByGeometry(place.geometry.location)
    }
  }

  search(address) {
    this.geocoder.geocode({ address: address }, function(results, status) {
      if (status === 'OK') {
        GeometryActions.change(results[0].geometry.location)
        LocationActions.getByGeometry(results[0].geometry.location)
      } else {
        // no results
      }
    })
  }

  handleTextInput(e) {
    e.preventDefault()

    if (e.keyCode === 13) {
      this.search(e.target.value)
    }
  }

  handleSearchClick(e) {
    e.preventDefault()

    const autoCompleteInput = document.getElementById('searchTextField')

    this.search(autoCompleteInput.value)
  }

  handleClick(e) {
    e.preventDefault()

    navigator.geolocation.getCurrentPosition(function(position) {
      // Create new google.maps.LatLng instance
      let geometry = new google.maps.LatLng(
        position.coords.latitude,
        position.coords.longitude
      )
      // Fire Geometry action
      GeometryActions.change(geometry)
      LocationActions.getByGeometry(geometry)
    })
  }

  render() {
    return (
      <div className="c-location-finder__search">
        <div className="o-layout  o-layout--flex  o-layout--flush">
          <div className="o-layout__item  o-layout__fill">
            <input
              id="searchTextField"
              onKeyUp={this.handleTextInput}
            />
          </div>
          <div className="o-layout__item  o-layout__fit">
            <button
              className="c-btn  c-btn--no-grow"
              onClick={this.handleSearchClick}
            />
          </div>
        </div>

        <div className="c-location-finder__search__location">
          <em>{this.props.translations.Search.Or}</em>{' '}
          <a href="#" onClick={this.handleClick}>
            {this.props.translations.Search.UseCurrentLocation}
          </a>
        </div>
      </div>
    )
  }
}

export default LocationPicker
